export const calculatePageCount = pageSize => count => Math.ceil(count / pageSize) || 1;
